import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import type { MaybeRef } from 'vue';

export const enum AppType {
  Flokee = 'flokee',
  Cleepo = 'cleepo',
}

interface AppState {
  current_app: MaybeRef<AppType | undefined>;
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    current_app: useStorage<AppType | undefined>('current_app', undefined, localStorage),
  }),
  getters: {
    currentAppName: (state) => {
      return state.current_app === AppType.Cleepo ? 'Cleepo' : 'Flokee';
    },
    currentAppLogo: (state) => {
      return state.current_app === AppType.Flokee
        ? '/images/logo.svg'
        : '/images/cleepo-logo-green-blue.png';
    },
    currentAppFavicon: (state) => {
      return state.current_app === AppType.Flokee
        ? '/favicon/favicon-flokee.ico'
        : '/favicon/favicon-cleepo.ico';
    },
  },
  actions: {
    setCurrentApp(app: AppType) {
      this.current_app = app;
    },
  },
});
